// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[8].oneOf[6].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[8].oneOf[6].use[2]!../../../node_modules/ui-connect/styles/colors.module.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Consent_consentBar__-KbtP {
    position: fixed;
    z-index: 110;
    width: 100%;
    left: 0;
    bottom: 0;
    background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["darkui_surface_4"]};
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["textDark"]};
    margin: 0 auto;
    font-size: 14px;
    font-family: "'Open Sans','HelveticaNeue','HelveticaNeueu',Arial,sans-serif";
}
`, "",{"version":3,"sources":["webpack://./src/standaloneComponents/Consent/Consent.module.css"],"names":[],"mappings":"AAEA;IACI,eAAe;IACf,YAAY;IACZ,WAAW;IACX,OAAO;IACP,SAAS;IACT,8DAAkC;IAClC,mDAAe;IACf,cAAc;IACd,eAAe;IACf,4EAA4E;AAChF","sourcesContent":["@value (textDark, darkui_surface_4) from 'ui-connect/styles/colors.module.css';\n\n.consentBar {\n    position: fixed;\n    z-index: 110;\n    width: 100%;\n    left: 0;\n    bottom: 0;\n    background-color: darkui_surface_4;\n    color: textDark;\n    margin: 0 auto;\n    font-size: 14px;\n    font-family: \"'Open Sans','HelveticaNeue','HelveticaNeueu',Arial,sans-serif\";\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"textDark": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["textDark"]}`,
	"darkui_surface_4": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["darkui_surface_4"]}`,
	"consentBar": `Consent_consentBar__-KbtP`
};
export default ___CSS_LOADER_EXPORT___;
